import type { IFieldProps } from '../elements/Field';
import type { FormContextProps } from '../elements/formContext';
import { translateKey } from '../../translate';
import { Feedback, Icon } from '../elements/common';
import { Component } from '../elements/Component';
import { Field } from '../elements/Field';
import { FormContextConsumer } from '../elements/formContext';

interface IPasswordInputProps {
    autoFocus?: boolean;
    disabled?: boolean;
    error?: string;
    name?: string;
    onChange: (value: string) => void;
    onDoValidate?: () => void;
    placeholder: string;
    scoreFromZeroToFive?: number;
    value: string;
}

interface IPasswordInputState {
    capsLock: boolean;
    showPassword: boolean;
}

export class PasswordInput extends Component<FormContextProps<IPasswordInputProps>, IPasswordInputState> {
    private changed = false;
    private keypressListener: (event: KeyboardEvent) => void;

    constructor(props: IPasswordInputProps, context?: any) {
        super(props, context);
        this.keypressListener = async (event: KeyboardEvent) => {
            await this.setState({ capsLock: event.getModifierState && event.getModifierState('CapsLock') });
        };
        this.state = {
            showPassword: false,
            capsLock: false,
        };
    }

    public componentDidMount() {
        window.addEventListener('keypress', this.keypressListener);
    }

    public componentWillUnmount() {
        window.removeEventListener('keypress', this.keypressListener);
    }

    public render() {
        return (
            <FormContextConsumer {...this.props}>
                {(properties) => (
                    <>
                        <div
                            className="input-container"
                            key="container"
                        >
                            <input
                                autoFocus={properties.autoFocus}
                                className={
                                    'form-control input-password' + (properties.error ? ' form-control-danger' : '')
                                }
                                disabled={properties.disabled}
                                name={properties.name}
                                onBlur={() => {
                                    if (properties.onDoValidate && this.changed) {
                                        properties.onDoValidate();
                                    }
                                }}
                                onChange={(e) => {
                                    this.changed = true;
                                    properties.onChange(e.target.value);
                                }}
                                placeholder={properties.placeholder}
                                type={this.state.showPassword ? 'text' : 'password'}
                                value={properties.value}
                            />
                            <button
                                className="icon-link show-password"
                                onClick={async () =>
                                    await this.setState(({ showPassword }) => ({ showPassword: !showPassword }))
                                }
                                tabIndex={-1}
                                type="button"
                            >
                                {this.state.showPassword ? <Icon icon="eye" /> : <Icon icon="eye crossed" />}
                            </button>
                            {properties.scoreFromZeroToFive !== undefined && (
                                <div className="form-validator">
                                    <span style={{ width: 100 - properties.scoreFromZeroToFive * 20 + '%' }}>
                                        &nbsp;
                                    </span>
                                </div>
                            )}
                            {this.state.capsLock && (
                                <div className="form-control-feedback">
                                    No design yet: {translateKey('common.capsLockWarning')}
                                </div>
                            )}
                        </div>
                        <Feedback
                            error={properties.error}
                            key="feedback"
                        />
                    </>
                )}
            </FormContextConsumer>
        );
    }
}

export function PasswordField(props: FormContextProps<IPasswordInputProps & IFieldProps>) {
    return (
        <Field {...props}>
            <PasswordInput {...props} />
        </Field>
    );
}
